import { Component, inject, OnInit, Signal } from '@angular/core';
import { AlertComponent } from '../../common/alert/alert.component';
import { BreadcrumbsComponent } from '../../common/breadcrumbs/breadcrumbs.component';
import { ContentComponent } from '../../components/content/content.component';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectCollection, selectLoading, selectPending } from '../../store/selectors/municipal-waste.selectors';
import { WasteCollectionAreaAppEntityWasteWasteCollectionAreaRead } from '../../openapi';
import { loadCollection } from '../../store/actions/municipal-waste.actions';
import { SpinnerComponent } from '../../common/spinner/spinner.component';
import { SessionService } from '../../services/ssession.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-municipal-waste-page',
  standalone: true,
  imports: [
    AlertComponent,
    BreadcrumbsComponent,
    ContentComponent,
    FormsModule,
    RouterLink,
    SpinnerComponent,
    ReactiveFormsModule,
    CommonModule
  ],
  templateUrl: './municipal-waste-page.component.html'
})
export class MunicipalWastePageComponent implements OnInit {

  public form: FormGroup = new FormGroup({
    area: new FormControl(null)
  });

  public authed: boolean = SessionService.Authed();

  private store$: Store = inject(Store);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public areas: Signal<WasteCollectionAreaAppEntityWasteWasteCollectionAreaRead[]> = this.store$.selectSignal(selectCollection);

  public ngOnInit(): void {
    this.store$.dispatch(loadCollection({ force: true }));
  }
}
